// Places a lower module's page offers modules above it (ADR 0064 step B): the project's and the organization's
// settings pages show cards of Source, Mini-app hosting and AI without depending on them; the web's host fills each
// slot at start (app/ports.tsx), in order.
import * as React from 'react';

export interface Slot<P> {
  /** The host fills the slot with a card (loaded when the page shows it). */
  provide(Card: React.ComponentType<P>): void;
  /** Every card of the slot, in the order they were provided. */
  Render(props: P): React.ReactNode;
}

function slot<P extends object>(): Slot<P> {
  const cards: React.ComponentType<P>[] = [];
  return {
    provide: (Card) => void cards.push(Card),
    Render: (props) => (
      <React.Suspense fallback={null}>
        {cards.map((Card, i) => (
          <Card key={i} {...props} />
        ))}
      </React.Suspense>
    ),
  };
}

/** The repository cards of a project's settings (its repositories, its repo check, its SDKs, its pull requests, its apps' outbound hosts). */
export const projectRepositoryCards = slot<{ slug: string; branch: string }>();
/** The AI cards of a project's settings (the AI tools' policy). */
export const projectAiCards = slot<Record<string, never>>();
/** The git cards of an organization (its git connections). */
export const organizationGitCards = slot<{ org: string }>();
/** The AI cards of an organization (its AI settings). */
export const organizationAiCards = slot<{ org: string }>();
